import { Routes, Route } from "react-router-dom";
import PublicSignUp from "./PublicSignUp";
import DefaultPage from "./DefaultPage";

import SuccessRouter from "./Success";        
import InstantSuccess from "./Success/InstantSuccess";
import RenewalSuccess from "./Success/RenewalSuccess";
import PayPage from "./Pay/PayPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<DefaultPage />} />

      {/* Payment link */}
      <Route path="/pay" element={<PayPage />} />

      {/* Success dispatcher */}
      <Route path="/success" element={<SuccessRouter />} />

      {/* Success pages */}
      <Route path="/success/instant" element={<InstantSuccess />} />
      <Route path="/success/renewal" element={<RenewalSuccess />} />

      {/* Signup */}
      <Route path="/:storeInfo" element={<PublicSignUp />} />

      <Route path="*" element={<div>404 – Page not found</div>} />
    </Routes>
  );
}

export default App;

